<template>
  <div class="d-flex flex-column text-center col-4 col-sm-2 mt-3 mt-sm-0">
    <img src="/img/icons/duracion.svg" alt="Duración estimada de la actividad" />
    <span class="texto-icono">{{ duration }}</span>
  </div>
</template>
<script>
export default {
  props: {
    duration: {
      type: String,
      require: true,
      default: '1h'
    }
  }
}
</script>
